// extracted by mini-css-extract-plugin
export default {"plans":"Plans_plans__VT-u-","plans_head":"Plans_plans_head__-17hU","plan_card":"Plans_plan_card__1Azby"};